/* eslint-disable @nice-cxone/ccf/required-tsdoc */
/**
 * This class to provide basic validation methods
 */
export class ValidationUtils {

    /**
     * This method to check value is not null or undefined
     * @param value  - any type of value
     * @example - 
     * ```
     * isNotNullOrUndefined('data');
     * ```
     * 
     * @returns  - true/false
     */
    isNotNullOrUndefined(value: any): boolean {
        if (value !== 'null' && value !== null && value !== 'undefined' && value !== undefined) {
            return true;
        }
        return false;
    }

    /**
     * This method to check value is not null or empty
     * @param value  - any type of value
     * @example - 
     * ```
     * isNotNullOrEmpty('data');
     * ```
     * 
     * @returns  - true/false
     */
    isNotNullOrEmpty(value: any): boolean {
        if (this.isNotNullOrUndefined(value) && value !== '') {
            return true;
        }
        return false;
    }


    /**
     * This method to check value is array is empty or not
     * @param value  - any type of value
     * @example - 
     * ```
     * isNotNullOrEmptyArray(['abc','xyz']);
     * ```
     * 
     * @returns  - true/false
     */
    isNotNullOrEmptyArray(value: any): boolean {
        if (value === undefined || value === null || value === ''
            || typeof value !== 'object' || !this.isNumber(value.length) || value.length === 0) {
            return false;
        }
        return true;
    }


    /**
     * This method to check value is number or not
     * @param value  - any type of value
     * @example - 
     * ```
     * isNumber(3);
     * ```
     * 
     * @returns  - true/false
     */
    isNumber(value: any): boolean {
        return !isNaN(parseFloat(value)) && isFinite(value);
    }

    isNullOrEmpty(value: any): boolean {
        return (value === undefined || value === null || value === '');
    }
            
    isValidObject(value: any) {
        return value !== null && typeof value === 'object' && Object.keys(value).length > 0;
    }
        
    isJSON(target: any) {
        try {
            const parsedData = JSON.parse(target);
            return (parsedData && typeof parsedData === 'object');
        } catch (e) {
            return false;
        }
    }

}